import {
  FaWhatsapp,
  FaPhoneAlt,
  FaStore,
  FaMapMarkerAlt,
  FaInstagram,
  FaFacebookF,
  FaTiktok,
  FaGlobe,
} from "react-icons/fa";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";

const SellerCard = ({ seller }) => {
  const { shopInfo, whatsappNumber, phoneNumber, image, name } = seller;

  // Status color mapping (placeholder logic)
  const status =
    seller.status === "active"
      ? "Taking orders online"
      : "Limited availability";
  const statusColor =
    seller.status === "active"
      ? "bg-green-100 text-green-700"
      : "bg-orange-100 text-orange-700";

  return (
    <div className="bg-card rounded-3xl shadow-sm border border-secondary/20 overflow-hidden flex flex-col h-full hover:shadow-md transition-shadow duration-300">
      {/* Header Area */}
      <div className="h-24 bg-secondary relative p-4 flex justify-end">
        <span
          className={`h-fit px-3 py-1 rounded-full text-xs font-medium ${statusColor}`}
        >
          {status}
        </span>

        {/* Floating Logo */}
        <div className="absolute -bottom-6 left-6 size-20 bg-white rounded-xl shadow-lg border border-slate-50 p-2 flex items-center justify-center overflow-hidden">
          {image ? (
            <img
              src={image}
              alt={shopInfo?.shopName}
              className="w-full h-full object-contain"
            />
          ) : (
            <FaStore className="text-slate-200 size-10" />
          )}
        </div>
      </div>

      {/* Content Area */}
      <div className="pt-10 px-6 pb-6 flex-grow flex flex-col">
        <h3 className="text-xl font-bold text-slate-800 mb-1">
          {shopInfo?.shopName || "Shop Name"}
        </h3>

        {/* <div className="flex items-center gap-2 text-primary/50 mb-3 text-xs">
                    <FaStore className="size-3.5" />
                    <span>{shopInfo?.category || 'MERCHANT'}</span>
                </div> */}

        <div className="flex items-start gap-2 text-primary/50 mb-4 text-xs">
          <FaMapMarkerAlt className="size-3.5 mt-0.5 flex-shrink-0" />
          <span className="leading-relaxed">
            {shopInfo?.shopPlaza
              ? `${shopInfo.shopPlaza}-${shopInfo.shopNumber}`
              : "No address provided"}
          </span>
        </div>

        <div className="flex flex-wrap items-center gap-3 mb-4">
          {seller.instagramHandle && (
            <a
              href={`https://instagram.com/${seller.instagramHandle.replace("@", "")}`}
              target="_blank"
              rel="noopener noreferrer"
              className="size-8 socialIcons"
              title="Instagram"
            >
              <FaInstagram className="size-5" />
            </a>
          )}
          {seller.facebookHandle && (
            <a
              href={
                seller.facebookHandle.startsWith("http")
                  ? seller.facebookHandle
                  : `https://facebook.com/${seller.facebookHandle}`
              }
              target="_blank"
              rel="noopener noreferrer"
              className="size-8 socialIcons"
              title="Facebook"
            >
              <FaFacebookF className="size-5" />
            </a>
          )}
          {seller.tiktokHandle && (
            <a
              href={`https://tiktok.com/@${seller.tiktokHandle.replace("@", "")}`}
              target="_blank"
              rel="noopener noreferrer"
              className="size-8 socialIcons"
              title="TikTok"
            >
              <FaTiktok className="size-5" />
            </a>
          )}
          {seller.websiteStoreLink && (
            <a
              href={seller.websiteStoreLink}
              target="_blank"
              rel="noopener noreferrer"
              className="size-8 socialIcons"
              title="Website"
            >
              <FaGlobe className="size-5" />
            </a>
          )}
        </div>

        {/* <p className="text-primary text-sm line-clamp-2 mb-4 leading-relaxed">
                    {shopInfo?.description || 'Your one-stop destination for quality products and exceptional service.'}
                </p> */}

        <div className="mt-auto border-t border-secondary/20 pt-4 mb-4">
          <p className="text-xs text-primary">
            Name: <span className="font-medium">{name || "N/A"}</span>
          </p>
        </div>

        {/* Action Buttons */}
        {/* Modern Action Suite */}
        <div className="mt-auto space-y-3">
          <Link
            to={`/seller/${seller._id}`}
            className="w-full btnPrimary !text-sm py-3 flex items-center justify-center gap-2 font-bold transition-all duration-300 shadow-lg shadow-slate-200 group-hover:shadow-secondary/20"
          >
            See All Products <MdOutlineKeyboardArrowRight className="size-5" />
          </Link>

          <div className="flex gap-2.5">
            <button
              onClick={() =>
                window.open(`https://wa.me/${whatsappNumber}`, "_blank")
              }
              className="flex-grow bg-green-100 border border-green-700 hover:bg-[#25D366] text-green-700 hover:text-white py-3 rounded-xl flex items-center justify-center gap-2 text-sm font-bold transition-all duration-300"
              title="Chat on WhatsApp"
            >
              <FaWhatsapp className="size-5" /> Message
            </button>
            <button
              onClick={() => (window.location.href = `tel:${phoneNumber}`)}
              className="px-5 bg-primary text-card py-3 rounded-xl flex items-center justify-center transition-all duration-300 border border-slate-100"
              title="Call Seller"
            >
              <FaPhoneAlt className="size-3.5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SellerCard;
